import { Controller, useFormContext } from 'react-hook-form';
import { FormInputText } from '@hopskipdrive/react-components';
import { useAuthQuery } from '@rideiq/auth/hooks/useAuthQuery';

import type { RiderFormValues } from '../../../types';

import { SubsectionLabel, SubsectionWrapper } from './styles';

const BASE_PLACEHOLDER = 'Add notes about any rider needs not covered by the above requirements';
const PHI_WARNING = 'DO NOT INCLUDE ANY PROTECTED HEALTH INFORMATION (PHI)';

export const AdditionalNotesSubsection = () => {
  const { control } = useFormContext<RiderFormValues>();
  const { userFeatures } = useAuthQuery();
  const hidePhi = !!userFeatures?.hidePhi;
  const placeholder = hidePhi ? `${BASE_PLACEHOLDER}\n${PHI_WARNING}` : BASE_PLACEHOLDER;

  return (
    <SubsectionWrapper data-testid="additional-notes-subsection">
      <SubsectionLabel as="label" htmlFor="riderNotes">
        Additional notes
      </SubsectionLabel>
      <Controller
        control={control}
        name="riderNotes"
        render={({ field: { value, onChange, onBlur } }) => (
          <FormInputText
            id="riderNotes"
            name="riderNotes"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            variant="outlined"
            multiline
            rows={4}
            inputProps={{ maxLength: 500 }}
            helperText="Max. 500 characters"
            sx={{ width: '100%' }}
          />
        )}
      />
    </SubsectionWrapper>
  );
};
